import { render } from "./ListDataIzinPending.vue?vue&type=template&id=820188fc"
import script from "./ListDataIzinPending.vue?vue&type=script&lang=js"
export * from "./ListDataIzinPending.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__